import { ERROR_TYPES } from 'src/config/constants'

class BaseError extends Error {
  errors: Record<string, string>[] | undefined
  constructor(message: string, errors?: Record<string, string>[]) {
    super(message)
    this.errors = errors
  }
}

export class NotFoundError extends BaseError {
  override name: string
  constructor(message: string, errors?: Record<string, string>[]) {
    super(message, errors)
    this.name = ERROR_TYPES.notFoundError
  }
}

export class ValidationError extends BaseError {
  override name: string
  constructor(message: string, errors?: Record<string, string>[]) {
    super(message, errors)
    this.name = ERROR_TYPES.validationError
  }
}

export class BadRequestError extends BaseError {
  override name: string
  constructor(message: string, errors?: Record<string, string>[]) {
    super(message, errors)
    this.name = ERROR_TYPES.validationError
  }
}

export class InternalError extends BaseError {
  override name: string
  constructor(message: string, errors?: Record<string, string>[]) {
    super(message, errors)
    this.name = ERROR_TYPES.internalError
  }
}

export class UnknownError extends BaseError {
  override name: string
  constructor(message: string, errors?: Record<string, string>[]) {
    super(message, errors)
    this.name = ERROR_TYPES.unknownError
  }
}
